import { type EmailTemplate } from '@/models/emailTemplate'
import { TemplateListItem } from './TemplateListItem'

interface TemplateListProps {
  templates: EmailTemplate[]
  selectedId: string | null
  onSelect: (id: string) => void
}

export function TemplateList({ templates, selectedId, onSelect }: TemplateListProps) {
  return (
    <ul className="flex flex-col gap-2">
      {templates.map((t) => (
        <li key={t.id}>
          <TemplateListItem template={t} selected={t.id === selectedId} onSelect={() => onSelect(t.id)} />
        </li>
      ))}
    </ul>
  )
}
